import { FC, useEffect } from 'react';
import useBenguide from 'hooks/benguide';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import AddPlanApiRequestPayload from 'model/AddPlanApiRequestPayload';
import Plan from 'model/Plan';
import { buildPlanRefsFromPlan } from 'modules/benefitsWellness/util';
import { TaxAdvantagedSection } from 'modules/taxAdvantaged/constants/taxAdvantagedConstants';
import {
  fetchHSAPlans,
  getDefaultMediaForHSA,
  getHSASection,
  getPlansFromPlanRefs,
  selectHSAPlans,
} from 'modules/taxAdvantaged/slices/hsaSlice';
import TaxAdvantagedPlanOverview from 'modules/taxAdvantaged/components/TaxAdvantagePlanOverview/TaxAdvantagedPlanOverview';

const HSAPlans: FC = () => {
  const dispatch = useAppDispatch();

  const { isEditMode, latestRevision } = useBenguide();

  const benguideData = useAppSelector((state) => state.benguide.data);
  const planRefs = useAppSelector((state) => state.hsa.hsaSection.plans);
  const planList = useAppSelector((state) => state.hsa.planList);
  const { data: selectedPlans, inProgress } = useAppSelector(
    (state) => state.hsa.selectedPlans
  );

  useEffect(() => {
    const { employerId, planYearId, benefitClasses } = benguideData || {};
    if (employerId && planYearId && isEditMode) {
      dispatch(
        fetchHSAPlans({
          employerId,
          planYearId,
          benefitClasses,
        })
      );
    }
  }, [dispatch, benguideData, isEditMode]);

  useEffect(() => {
    dispatch(
      getHSASection({
        benguideId: benguideData.masterId,
      })
    );
  }, [dispatch, benguideData.masterId, latestRevision]);

  useEffect(() => {
    dispatch(getPlansFromPlanRefs({ planRefs }));
  }, [dispatch, planRefs]);

  useEffect(() => {
    if (selectedPlans.length > 0) {
      dispatch(
        getDefaultMediaForHSA(benguideData.masterId, selectedPlans[0].id)
      );
    }
  }, [dispatch, selectedPlans, benguideData]);

  const handleSave = (planList: Plan[], orderByPlanNames: boolean) => {
    const planRefs = planList.map((plan) =>
      buildPlanRefsFromPlan(plan, plan.benefitKind)
    );
    const payload: AddPlanApiRequestPayload = {
      orderByPlanNames: orderByPlanNames,
      plans: planRefs,
      sectionName: 'HSA',
    };

    dispatch(
      selectHSAPlans({
        addPlansPayload: payload,
        benefitKind: 'HSA',
        benguideId: benguideData.masterId,
      })
    );
  };

  return (
    <TaxAdvantagedPlanOverview
      onSelectPlans={handleSave}
      planList={planList.data}
      planListLoading={planList.inProgress}
      planRefs={planRefs}
      section={TaxAdvantagedSection.HSA}
      selectedPlans={selectedPlans}
      selectedPlansLoading={inProgress}
    />
  );
};

export default HSAPlans;
